import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import i18n from 'i18next';

import { getSafeText} from '../../utils/valueResolver';


function MaintenanceSummary({ icon, title, items, historyLink }) {
  const { t } = useTranslation();
  const lang = i18n.language;

  const hasValidItems =
    Array.isArray(items) &&
    items.some((item) =>
      Object.values(item).some((value) => {
        if (Array.isArray(value)) return value.length > 0;
        if (value && typeof value === 'object') {
          return Object.values(value).some((v) => v); // 多言語オブジェクトでも true
        }
        return value !== null && value !== undefined && value !== '';
      })
    );


  return (
    <>
      <div className="section-title">
        <span className={`icon ${icon}`}>
          <img
            src={`/images/icon/${icon}.svg`}
            alt={getSafeText(title)}
            width="20"
            height="20"
          />
        </span>
        <span className="title-text">{getSafeText(title)}</span>
      </div>

      <section
        className="list-section"
        style={!hasValidItems ? { borderBottom: 'none' } : {}}
      >
        {hasValidItems ? (
          <div className="list-table">
            {items.map((item, index) => (
              <div className="list-row" key={index}>
                <div className="list-label">{getSafeText(item.label)}</div>
                <div className="list-value">{getSafeText(item.value)}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="maintenance-empty">
            {t('maintenanceSummary.noHistory', {
              title: getSafeText(title),
            })}
          </div>
        )}
      </section>

      {hasValidItems && (
        <nav className="history-nav">
          <Link
            to={{ pathname: historyLink.pathname, search: historyLink.search }}
            state={historyLink.state}
            className="history-link"
          >
            <span>{t('maintenanceSummary.viewHistory')}</span>
            <span className="icon icon-arrow-right">
              <img
                src="/images/icon/icon_arrow_right.svg"
                alt={t('maintenanceSummary.viewHistoryAlt', {
                  title: getSafeText(title),
                })}
                width="15"
                height="15"
              />
            </span>
          </Link>
        </nav>
      )}
    </>
  );
}

export default MaintenanceSummary;